<div class="meter-consumptions-filter-container" *ngIf="filterOptions.length > 0">
  <div class="upper-filter-options-container" *ngIf="upperFilterOptions.length > 0">
    <span class="upper-filter-title">Netzbezug</span>
    <span class="upper-filter-options" *ngFor="let option of upperFilterOptions; let i = index">
      <mat-checkbox [checked]="!!option.label" (click)="select(option)"> {{ option.label }} </mat-checkbox>
    </span>
  </div>

  <div class="upper-filter-options-container" *ngIf="lowerFilterOptions.length > 0">
    <span class="upper-filter-title">Erzeugung</span>
    <span class="upper-filter-options" *ngFor="let option of lowerFilterOptions; let i = index">
      <mat-checkbox [checked]="!!option.label" (click)="select(option)"> {{ option.label }} </mat-checkbox>
    </span>
  </div>
</div>
